import { Button, Card, CardMedia, Grid2, Stack } from "@mui/material";
import IndieUploadButton from "components/forms/IndieUploadButton";
import { useFormikContext } from "formik";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const BannerImageUpload = ({ fieldName, imageSrc, isFormDisabled, showDelete=true }) => {

    const { t } = useTranslation();
    const [preview, setPreview] = useState(null);
    const formik = useFormikContext();

    const handlePhotoChange = (event) => {
        const file = event.currentTarget.files[0];
        if (file) {
            formik.setFieldValue(fieldName, file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDelete = () => {
        formik.setFieldValue(fieldName, null);
        setPreview(null);
    }

    useEffect(() => {
        if (imageSrc) {
            setPreview(imageSrc);
        }
    }, [imageSrc]);

    return (
        <Fragment>
            <Grid2 container spacing={4}>
                <Grid2 item size={{ xs: 12, md: 5 }}>
                    <Card
                        variant="outlined"
                        sx={{
                            width: "100%",
                            position: "relative",
                        }}
                    >
                        <CardMedia
                            component="img"
                            alt="Image Preview"
                            image={preview ?? "/static/images/comunidades_energia_banner_01.jpeg"}
                            sx={{ width: "100%", height: "200px", objectFit: "cover" }}
                        />
                    </Card>
                </Grid2>

                {!isFormDisabled && (
                    <Grid2 item size={{ xs: 12, md: 7 }}>
                        <label htmlFor="photo-upload" style={{ width: "100%", display: "block" }}>
                            <input
                                style={{ display: 'none' }}
                                id="photo-upload"
                                name="photo"
                                type="file"
                                onChange={handlePhotoChange}
                            />
                            <Stack spacing={2} sx={{width: "100%"}} alignItems="flex-start">
                                <IndieUploadButton 
                                    id="upload_photo" 
                                    fullWidth 
                                    component="span" 
                                    variant="contained" 
                                    color="primary" 
                                    label={t("label.form.uploadPhoto")} 
                                    sx={{width:"200px"}}
                                />
                                {showDelete && (
                                    <Button 
                                        id="delete" 
                                        variant="outlined" 
                                        color="neutral" 
                                        onClick={handleDelete} 
                                        sx={{width:"200px"}}
                                    >
                                        {t("label.form.delete")}
                                    </Button>
                                )}
                            </Stack>
                        </label>
                    </Grid2>
                )}
            </Grid2>
        </Fragment>
    )
}

export default BannerImageUpload;